import { css, styled } from 'styled-components';

/* NOTE: We avoid theme tokens (COLORS, GRADIENTS, SCREEN_SIZE)
 * because LoadingSpinner renders before ThemeProvider inside <Suspense fallback>. */

const SCREEN_SIZE = {
  DESKTOP_WIDTH: '1080px',
  TABLET_WIDTH: '768px',
};

export const LoadingSpinnerContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 99999999;
  display: flex;
  flex-direction: column;
  background-color: #f4f5f2;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;

  ${({ theme }) =>
    theme?.isKioskRootElementType
      ? css`
          width: 1080px;
          height: 400px;
        `
      : css`
          width: 100%;
          height: 240px;

          @media screen and (min-width: ${SCREEN_SIZE.DESKTOP_WIDTH}) {
            height: 400px;
          }
        `}
`;

export const Spinner = styled.div`
  --gradient: conic-gradient(#0000, #000), linear-gradient(#000 0 0) content-box;
  @keyframes load {
    to {
      transform: rotate(1turn);
    }
  }

  box-sizing: border-box;
  width: 66px;

  /* the size */
  aspect-ratio: 1;
  padding: 11px;

  /* the border thickness */
  background-color: var(--color-primary-600, #367a86);

  /* the color */
  border-radius: 50%;
  mask: var(--gradient);
  mask-composite: subtract;
  animation: load 1s linear infinite;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  padding: 32px;
  max-width: 642px;
  margin: 0 auto;

  @media screen and (min-width: ${SCREEN_SIZE.TABLET_WIDTH}) {
    padding: 64px;
  }
`;
